/**
 * Placeholder color definitions until
 * @sanity/color is updated with new branding
 */

export const NEW_SANITY_ORANGE = '#FF5500'
export const NEW_SANITY_BLACK = '#0D0E12'
